import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

function getSrcLink(image) {
  return `${process.env.REACT_APP_CLOUDFRONT_LINK}/assets/images/sr/cardBrands/${image}`;
}

// American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown
const BrandIconMap = {
  diners: getSrcLink('dinersClub.svg'),
  amex: getSrcLink('amex.svg'),
  jcb: getSrcLink('jcb.svg'),
  discover: getSrcLink('discover.svg'),
  visa: getSrcLink('visa.svg'),
  mastercard: getSrcLink('mastercard.svg'),
  unionpay: getSrcLink('unionPay.svg'),
};

function CardBrandIcon({ brand, type, ...props }) {
  const iconSrc = BrandIconMap[String(brand).toLowerCase()];

  if (type === 'us_bank_account') {
    return <Icon {...props} fontSize="large" component={AccountBalanceIcon} />;
  }

  return iconSrc ? <img alt="brand-icon" src={iconSrc} {...props} /> : null;
}

CardBrandIcon.propTypes = {
  brand: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default React.memo(CardBrandIcon);
